import React, { FC } from 'react';
import { AllFbtItems, CurrentItems } from 'services/fbtItems/types';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import FbtItemCard from './fbt-item-card';
interface FBTProductListProps {
  products: AllFbtItems[];
  partsPriceData: ProductDealerPriceAvailability[];
  currency: string;
  isCatCorp: boolean;
  frequestBoughtMobile: boolean;
  contactDealerComp?: React.ReactNode;
  handleCheckboxChange?: (
    e: CustomEvent<{ checked: boolean; indeterminate: boolean; value: string }>
  ) => void;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
  cartId: string;
  storeLocationId: string;
  startIndex: number;
}

const FBTProductList: FC<FBTProductListProps> = ({
  products,
  partsPriceData,
  currency,
  isCatCorp,
  frequestBoughtMobile,
  handleCheckboxChange,
  contactDealerComp,
  storeLocationId,
  isRTL = false,
  cartId,
  startIndex,
  currencyLdFeatureFlag = false
}) => {
  return (
    <>
      {products.map((fbtItem: CurrentItems, index) => {
        return (
          <FbtItemCard
            key={fbtItem?.partNumber}
            fbtItem={fbtItem}
            partsPriceData={partsPriceData}
            currency={currency}
            isCatCorp={isCatCorp}
            frequestBoughtMobile={frequestBoughtMobile}
            handleCheckboxChange={handleCheckboxChange}
            contactDealerComp={contactDealerComp}
            isRTL={isRTL}
            currencyLdFeatureFlag={currencyLdFeatureFlag}
            startIndex={startIndex + index}
            cartId={cartId}
            storeLocationId={storeLocationId}
          />
        );
      })}
    </>
  );
};

export default FBTProductList;
